// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import DateField from "../../ui/DateField";
import { bm_date } from "../../utils/Utils";
import { ENUMS } from "../../utils/Enums";
import { drawPicker } from "../../popovers/Picker";
import { ROUTES } from "../../utils/Routes";
import SelectBox from "../../ui/SelectBox";
import { KBD } from "../../utils/Keybindings";

export default function GenericConditional(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, allow_in = false, date = false, edit = false, inputParams = { number: true, maxLength: 3, width: 35 } } = props;

    const route = ROUTES.REPORTS.FILTER_EDIT;
    const { value = 1, type = "" } = filter;

    let text = filter.text;
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
    }

    const fields = [
        { key: "comparison", value: (edit) ? filter.comparison : "=", help: "" },
        { key: "value_1", value: (edit) ? filter.value_1 : (inputParams.number) ? "" : "", help: "Enter the data to complete this filter." },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const comparison = tabs.find(f => f.key === "comparison").value;
        let value_1 = tabs.find(f => f.key === "value_1").value;

        if (date) {
            value_1 = bm_date(value_1, "YYYY-MM-DD");
        }

        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
            value_1: value_1.toString()
        }
        onSave(_f, filter);
    }

    return (
        <FilterBase controller={controller} start_index={0} fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed, refs, index }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <SelectBox
                            width={110}
                            {...editProps("comparison")}
                            options={[
                                { value: "=", label: "Equal to" },
                                { value: "<", label: "Less than"},
                                { value: ">", label: "Greater than"},
                            ]}
                        />
                        {(!date && <Input {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />)}
                        {(date && <DateField {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />)}
                        <Button onClick={() => save(tabs)} {...editProps("save")} >Save</Button>
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}
